var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-svg",
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-pin",
    "data-name": "Icon ionic-ios-pin",
    d: "M30.769,3.375C18.13,3.375,7.875,12.9,7.875,24.632c0,16.535,22.894,44.883,22.894,44.883S53.664,41.167,53.664,24.632C53.664,12.9,43.409,3.375,30.769,3.375Zm0,30.351a7.457,7.457,0,1,1,7.457-7.457A7.457,7.457,0,0,1,30.769,33.726Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.906d8bc7cf2f733b1768dd358a9cb16a.svg";
export { ForwardRef as ReactComponent };